<template>
  <div class="register-container">
    <el-row style="margin: 0 20px;">
      <el-col style="margin-top: 25vh; " :xs="24" :sm="{ span: 18, offset: 3 }" :md="{ span: 16, offset: 4 }"
        :lg="{ span: 10, offset: 7 }" :xl="{ span: 10, offset: 7 }">
        <el-card v-loading="loading" element-loading-text="努力注册中，稍等一下" style="background: rgba(255, 255, 255, 0.97);">
          <el-steps :active="step" finish-status="success" align-center>
            <el-step title="填写邮箱" icon="el-icon-message"></el-step>
            <el-step title="用户名密码" icon="el-icon-user-solid"></el-step>
            <el-step title="完成注册" icon="el-icon-success"></el-step>
          </el-steps>
          <!--填写邮箱-->
          <div v-show="step === 0" style="height: 220px">
            <el-form ref="emailForm" :model="emailForm" :rules="verifyEmailRules" style="height: 190px;">
              <el-row :gutter="10">
                <el-col>
                  <el-form-item prop="email">
                    <el-input v-model="emailForm.email" ref="email" placeholder="邮箱">
                      <i slot="prefix" class="el-input__icon el-icon-message" />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="code">
                    <el-input ref="code" v-model="emailForm.code" auto-complete="off" placeholder="邮箱验证码">
                      <i slot="prefix" class="el-input__icon el-icon-key" />
                      <el-button slot="append" @click="openVerifyDialog()">获取邮箱验证码</el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="display: flex; flex-direction: row; justify-content: space-between">
              <el-button type="text" @click="toLogin()">去登录</el-button>
              <el-button type="primary" @click="emailCompleted()">下一步</el-button>
            </div>
          </div>
          <!--填写用户名密码-->
          <div v-show="step === 1" style="height: 220px">
            <el-form ref="userForm" :model="userForm" :rules="userFormRules" style="height: 190px;">
              <el-form-item prop="username">
                <el-input v-model="userForm.username" :max="20" placeholder="用户名，也是登录账号">
                  <i slot="prefix" class="el-input__icon el-icon-user-solid" />
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="userForm.password" :max="20" type="password" show-password placeholder="密码">
                  <i slot="prefix" class="el-input__icon el-icon-lock" />
                </el-input>
              </el-form-item>
              <el-form-item prop="repeatPwd">
                <el-input v-model="userForm.repeatPwd" :max="20" type="password" show-password placeholder="确认密码">
                  <i slot="prefix" class="el-input__icon el-icon-lock" />
                </el-input>
              </el-form-item>
            </el-form>
            <div style="display: flex; flex-direction: row; justify-content: space-between;">
              <el-button type="primary" @click="toEmail()">上一步</el-button>
              <el-button type="primary" @click="handleRegister()">完成</el-button>
            </div>
          </div>
          <!--注册完成-->
          <div v-show="step === 3" style="height: 220px">
            <div style="height: 190px;">
              <el-result icon="success" title="恭喜你，注册成功" subTitle="请前往登录页登录"></el-result>
            </div>
            <div style="display: flex; flex-direction: row; justify-content: center;">
              <el-button type="primary" @click="toLogin()">去登录</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="验证" :visible.sync="showVerifyCodeDialog" @close="closeDialog" top="30vh" width="330px"
      append-to-body>
      <el-form ref="verifyCodeForm" :model="verifyCodeForm" :rules="verifyCodeFormRules" label-width="20px">
        <el-row>
          <el-col>
            <el-form-item prop="verifyCode">
              <el-input v-model="verifyCodeForm.verifyCode" ref="verifyCodeInput" auto-complete="off" style="width: 63%"
                placeholder="请输入验证码">
                <i slot="prefix" class="el-input__icon el-icon-key" />
              </el-input>
              <div class="login-code">
                <img :src="codeUrl" alt="" @click="getCode" class="login-code-img" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getMailVerifyCode">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!--  底部  -->
    <div class="el-register-footer">
      <span>Copyright © {{ copyrightTime }} fengling.work All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
import { getCodeImg, sendMail, register } from "@/api/login";
import { getCopyrightTime } from "@/utils/date";

export default {
  name: "Register",
  data() {
    // 自定义的确认密码表单验证
    const validateRepeatPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致！'));
      } else {
        callback();
      }
    }
    return {
      step: 0,
      loading: false,
      verifyCodeForm: {
        verifyCode: ''
      },
      emailForm: {
        email: '',
        code: ''
      },
      userForm: {
        username: '',
        password: '',
        repeatPwd: ''
      },
      captchaEnabled: true,
      codeUrl: '',
      showVerifyCodeDialog: false,
      // 验证邮箱
      verifyEmailRules: {
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          {
            pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: '邮箱格式不正确', trigger: 'blur'
          }
        ],
      },
      // 验证码
      verifyCodeFormRules: {
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      userFormRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { min: 2, message: '用户名必须在2到20个字符之间', trigger: 'blur' },
          { max: 20, message: '用户名必须在2到20个字符之间', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码长度必须在6到20个字符之间', trigger: 'blur' },
          { max: 20, message: '密码长度必须在6到20个字符之间', trigger: 'blur' },
        ],
        repeatPwd: [
          { validator: validateRepeatPwd, trigger: 'blur' }
        ]
      },
      copyrightTime: getCopyrightTime()
    }
  },
  created() {

  },
  metaInfo() {
    return {
      title: '欢迎注册 | 风铃笔记',
    }
  },
  methods: {
    // 验证码
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.data.img;
          this.verifyCodeForm.uuid = res.data.uuid;
        }
      });
    },
    // 打开验证码对话框
    openVerifyDialog() {
      this.$refs.emailForm.validate(valid => {
        if (!valid) {
          this.$modal.msgWarning('请正确输入邮箱')
          this.$refs.email.focus();
          return;
        }
        this.showVerifyCodeDialog = true;
        this.$nextTick(() => {
          this.getCode();
          this.$refs.verifyCodeInput.focus();
        });
      });
    },
    // 获取邮箱验证码
    getMailVerifyCode() {
      this.$refs.verifyCodeForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.verifyCodeForm.email = this.emailForm.email;
        sendMail(this.verifyCodeForm).then(() => {
          this.$modal.msgSuccess('验证码已发送到您的邮箱，请注意查收');
          this.showVerifyCodeDialog = false
        }).catch(() => {
          if (this.captchaEnabled) {
            this.getCode();
          }
        })
      });
    },
    emailCompleted() {
      this.$refs.emailForm.validate(validate => {
        if (!validate) {
          this.$modal.msgWarning('请正确输入邮箱')
          this.$refs.email.focus();
          return;
        }
        if (!this.emailForm.code) {
          this.$modal.msgWarning('请填写邮箱验证码')
          this.$refs.code.focus();
          return;
        }
        this.step = 1;
      });
    },
    // 注册账号
    handleRegister() {
      this.$refs.userForm.validate(validate => {
        if (!validate) {
          return;
        }
        this.loading = true;
        let registerData = {
          email: this.emailForm.email,
          code: this.emailForm.code,
          username: this.userForm.username,
          password: this.md5(this.userForm.password)
        }
        register(registerData).then(res => {
          this.$modal.msgSuccess('注册成功')
          this.step = 3;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    // 跳转到登录页
    toLogin() {
      this.$router.replace('/login')
    },
    // 关闭验证码弹窗
    cancel() {
      this.showVerifyCodeDialog = false;
    },
    toEmail() {
      this.step = 0;
    },
    // 关闭弹窗回调
    closeDialog() {
      this.verifyCodeForm.verifyCode = '';
    }
  }
}
</script>

<style lang="less" scoped>
.register-container {
  height: 100vh;
  background-image: url("../../assets/img/bg01.jpg");
  background-size: cover;
}

.login-code {
  width: 36%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }

  .login-code-img {
    height: 38px;
  }
}

::v-deep .el-dialog__body {
  padding: 10px 0;
}

.el-register-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
</style>
